import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import { FaArrowUp } from 'react-icons/fa6';
import {
  displayValue,
  displayValueWithUnit,
  hasValue,
} from '../../../../../../../utils/valueFormatting/display.utils';

export const day15WeatherDetails = [
  {
    id: 'high',
    label: 'High',
    iconKey: WEATHER_DETAIL_ICON_KEYS.HIGH_TEMPERATURE,
    getValue: (data) => displayValueWithUnit(data?.high_temp, '°F'),
  },
  {
    id: 'windSpeed',
    label: 'Wind',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_SPEED,
    getValue: (data) => displayValueWithUnit(data?.wind_speed, ' MPH'),
  },
  {
    id: 'windDirection',
    label: 'Wind Direction',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_DIRECTION,
    getValue: (data) => (
      <div className="d-flex align-items-center gap-1">
        <span>{`${displayValue(data?.wind_short)} (${displayValue(data?.wind_dir)}°)`}</span>
        {hasValue(data?.wind_dir) && (
          <FaArrowUp
            aria-hidden="true"
            focusable="false"
            size={16}
            style={{ transform: `rotate(${data.wind_dir}deg)` }}
          />
        )}
      </div>
    ),
  },
  {
    id: 'low',
    label: 'Low',
    iconKey: WEATHER_DETAIL_ICON_KEYS.LOW_TEMPERATURE,
    getValue: (data) => displayValueWithUnit(data?.low_temp, '°F'),
  },
  {
    id: 'humidity',
    label: 'Humidity',
    iconKey: WEATHER_DETAIL_ICON_KEYS.HUMIDITY,
    getValue: (data) => displayValueWithUnit(data?.humidity, '%'),
  },
  {
    id: 'precipitationProbability',
    label: 'Precipitation',
    iconKey: WEATHER_DETAIL_ICON_KEYS.PRECIPITATION_PROBABILITY,
    getValue: (data) => displayValueWithUnit(data?.precip_prob, '%'),
  },
  {
    id: 'comfort',
    label: 'Feels Like',
    iconKey: WEATHER_DETAIL_ICON_KEYS.COMFORT,
    getValue: (data) => displayValueWithUnit(data?.comfort, '°F'),
  },
  {
    id: 'skyCondition',
    label: 'Sky',
    iconKey: WEATHER_DETAIL_ICON_KEYS.SKY_CONDITION,
    getValue: (data) => displayValue(data?.sky),
    getIconProps: (data) => ({ conditionId: Number.parseInt(data?.icon || '0', 10) }),
  },
  {
    id: 'dewPoint',
    label: 'Dew Point',
    iconKey: WEATHER_DETAIL_ICON_KEYS.DEW_POINT,
    getValue: (data) => displayValueWithUnit(data?.dew_point, '°F'),
  },
];
